import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const charMap: Record<string, string> = {
  ç: "c",
  Ç: "c",
  ğ: "g",
  Ğ: "g",
  ı: "i",
  İ: "i",
  ö: "o",
  Ö: "o",
  ş: "s",
  Ş: "s",
  ü: "u",
  Ü: "u",
};

const normalizePath = (path: string) => {
  const decoded = decodeURIComponent(path);
  const mapped = decoded
    .split("")
    .map((ch) => charMap[ch] ?? ch)
    .join("")
    .toLowerCase();

  const singleSlash = mapped.replace(/\/{2,}/g, "/");
  if (singleSlash === "/") return "/";
  return singleSlash.endsWith("/") ? singleSlash.slice(0, -1) : singleSlash;
};

const CanonicalUrlGuard = () => {
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const normalized = normalizePath(pathname);
    if (normalized !== pathname) {
      navigate(`${normalized}${search}${hash}`, { replace: true });
    }
  }, [pathname, search, hash, navigate]);

  return null;
};

export default CanonicalUrlGuard;
